/* ==========================================================================
  Main.js
========================================================================== */
// Aucor navigation
aucor_navigation( document.getElementById('primary-navigation'), {
  desktop_min_width:  501,            // min width in pixels
  menu_toggle:        '#menu-toggle'  // selector for toggle
});

var comment_help = document.querySelector('.comment-help');
if(comment_help) {
  comment_help.addEventListener('click', function(e) {
    e.preventDefault();
    var comment_info = document.querySelector('.comment-info');
    comment_info.classList.toggle('show');
  });
}
// Responsive videos
// fitvids();

/**
 * Need jQuery? Add jQuery as dependency in functions.js and uncomment the following
 */
/*
(function($) {
  $(document).ready(function(){

  });
})(jQuery);
*/
